import eventManager from '../../helpers/eventManager'

export default 
{
    send: (url, callback = () => {}) => {
        eventManager.triggerEvent("REDIRECT", {url: url, callback: callback})
    }
}
